module.exports = __webpack_public_path__ + "static/ss11.fa193113.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss11.png
// module id = 1188
// module chunks = 81679748166845